import React, {useContext} from 'react'
import {dataContext,localestr} from '../utils.js'
import EditCtrl from '../cmp/EditCtrl.js';
import EditFld from '../cmp/EditFld.js';

function FldDiscountsEdit({data,actions}){
    let wndData=''
    if(data) wndData=data.wndData
    else wndData=actions.getWndData()
    const setWndData=actions.setWndData
    const tabChoice=actions.tabChoice
    const tabClose=actions.tabClose
    
    const context=useContext(dataContext)
    const saveData=context.saveData
    const msg=context.msg

    const setValue=(name,data)=>{
        let newData={...wndData,changed:true}
        if (data==='') newData[name]=null
        else newData[name]=data
        setWndData(newData)
    }

    const saveValue=()=>{
        let errmsg=''
        const name=(wndData.name || '').substring(0,50)
        const parent=wndData.parent || {id:null,name:null}
        const id=wndData.id

        if (name===null || name==='') errmsg=localestr("Не заповнено ім'я")
        if (parent.id===id && id) errmsg=errmsg+localestr("Некоректна папка")
        if (parent.parent) {
            if (parent.parent.id===id && id) errmsg=errmsg+localestr("Некоректна папка")
            if(parent.parent.parent){
                if (parent.parent.parent.id===id && id) errmsg=errmsg+localestr("Некоректна папка")
                if(parent.parent.parent.parent){
                    if (parent.parent.parent.parent.id===id && id) errmsg=errmsg+localestr("Некоректна папка")
                    if(parent.parent.parent.parent.parent){
                        if (parent.parent.parent.parent.parent.id===id && id) errmsg=errmsg+localestr("Некоректна папка")
                        
                    }
                }
            }
        }
        if (errmsg!=='') msg(errmsg,localestr('Помилка'),[{caption:'OK',action:()=>{}}])
        else{
            if (id===null || id==='' || id===undefined){
                let newData={status:'add',key:'FldDiscounts',data:{name,parent}}
                saveData(newData,tabClose)
                //почекати ы закрити выкно
            }  
            else if(wndData.changed) {
                let newData={status:'mod',key:'FldDiscounts',data:{id,name,parent}}
                //saveData(newData,tabClose)
                saveData(newData,d=>{if(wndData.update) wndData.update(d.data);if(tabChoice) tabChoice(d.data);tabClose()})
            }        
            else tabClose()
        }

    }

    return(

    <div style={{display:'flex',flexDirection:'column', margin:'4px 0'}}>
        <div style={{margin:'2px 0',display:'inherit'}}>
    <EditCtrl Capt={'Id'} Value={wndData.id} typeVal={'text'} setVal={(d)=>{setValue('id',d)}} width1='46' width2='50' disabled={true}/>
    <div style={{width:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
    <EditFld Capt={localestr('Папка')} Value={wndData.parent} typeVal={'fldDiscounts'} setVal={(d)=>{setValue('parent',d)}} width1='50' width2='183' />
        </div>
    <EditCtrl Capt={localestr('Назва')} Value={wndData.name} typeVal={'text'} setVal={(d)=>{setValue('name',d)}} width1='50' width2='287'/>

    <div style={{width:'54px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{saveValue()}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>OK</div></div>
    </div>
    )
    
}

export default FldDiscountsEdit